import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { getContent } from "../lib/api";
import { Star, X } from "lucide-react";

export default function Prophets() {
  const { t } = useApp();
  const [list, setList] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { getContent("prophets").then(setList); }, []);

  return (
    <div className="space-y-6 fade-in" data-testid="prophets-page">
      <header className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-nour-primary text-white flex items-center justify-center"><Star className="w-6 h-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-bold">{t.prophets}</h1>
          <p className="text-sm text-nour-text2">25 prophètes du Coran</p>
        </div>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="prophets-grid">
        {list.map(p => (
          <button
            key={p.id}
            onClick={() => setActive(p)}
            data-testid={`prophet-${p.id}`}
            className="nour-card p-4 text-left hover:bg-emerald-50 transition flex items-start gap-3"
          >
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-50 to-emerald-100 flex items-center justify-center shrink-0">
              <span className="font-heading font-bold text-nour-primary">{p.id}</span>
            </div>
            <div className="flex-1">
              <div className="font-arabic-quran text-xl text-nour-primary" dir="rtl">{p.ar}</div>
              <div className="font-heading font-semibold mt-1">{p.name}</div>
              <div className="text-xs text-nour-text2 line-clamp-2 mt-1">{p.miracle_fr}</div>
            </div>
          </button>
        ))}
      </div>

      {active && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={() => setActive(null)} data-testid="prophet-modal">
          <div className="nour-card p-6 max-w-lg w-full max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start">
              <div>
                <div className="font-arabic-quran text-3xl text-nour-primary" dir="rtl">{active.ar}</div>
                <h2 className="font-heading text-2xl font-bold mt-1">{active.name}</h2>
              </div>
              <button onClick={() => setActive(null)} data-testid="prophet-modal-close"><X className="w-5 h-5"/></button>
            </div>
            <div className="mt-5 nour-card p-4 bg-gradient-to-br from-amber-50 to-yellow-50">
              <div className="text-xs uppercase tracking-wider text-nour-text2 mb-1">{t.miracle}</div>
              <p className="text-sm text-nour-text">{active.miracle_fr}</p>
            </div>
            <div className="mt-4">
              <div className="text-xs uppercase tracking-wider text-nour-text2 mb-1">{t.story}</div>
              <p className="text-sm text-nour-text leading-relaxed">{active.story_fr}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
